import TopicRelations from './TopicRelations';

export default TopicRelations;
